
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/splitbox.en.md?watch=parent';
    export const toc = [{"id":"splitbox","depth":2,"title":"SplitBox"}];
export const frontmatter = {"title":"SplitBox","toc":"menu","filename":"docs/temp/ui/splitbox.en.md","lastUpdated":1729244528000,"order":12,"redirect_from":["/en/docs","/en/docs/api","/en/docs/api/ui"],"description":"Split Panel."};